import Colors from "./LightModeThemeColors";

export const ThemeColors = Colors;
